import AboutTeamContainer from './AboutTeamContainer';

export default AboutTeamContainer;